import _ from 'lodash';

const FALLBACK_MESSAGE = 'Error! Refresh page and try again please. Contact us if the error persists';

/**
 * Extracts a human readable string from whatever was passed to notifications.error():
 * a string, an Error, an axios error/response or a DRF style errors object.
 */
export default function normalizeErrorMessage(message = 'Error') {
    if (_.isObject(message) && message.response) {
        message = message.response; // axios fix
    }
    let _message = '';

    if (_.isObject(message) && message.status && !message.data) {
        if (message.status === 403) {
            message = 'You do not have permission to perform this action';
        }
        if (message.status === 400) {
            message = 'Invalid data';
        }
        if (message.status === 404) {
            message = 'Not found';
        }
    }
    if (message?.response) {
        message = message.response; // axios fix
    }
    if (message instanceof Error) {
        message = message.name + ': ' + message.message;
    }
    if (_.isObject(message) && message.data) {
        message = message.data;
    }
    if (_.isObject(message)) {
        if (_.isArray(message)) {
            for (const val of message) {
                _message += val;
            }
        } else {
            for (const field of Object.values(message)) {
                _message += field;
            }
        }
    } else {
        _message = message;
    }
    if ((_message?.length > 3000) || (_message === undefined)) {
        _message = FALLBACK_MESSAGE;
    }
    return _message;
}
